/**
 *
 * @param {String} contentType The Contentful GraphQL type
 * @returns The human-readable label for the given content type
 */
const getContentTypeLabel = (contentType) => {
  const contentTypes = {
    LearningCenterArticle: 'Article',
    LearningCenterCalculator: 'Calculator',
    LearningCenterGuide: 'Guide',
    CustomerStory: 'Customer Story',
    CaseStudy: 'Case Study',
  };

  return contentTypes[contentType];
};

export default getContentTypeLabel;
